import { render, staticRenderFns } from "./PriceDistributionListPage.vue?vue&type=template&id=64e1f292&"
import script from "./PriceDistributionListPage.vue?vue&type=script&lang=ts&"
export * from "./PriceDistributionListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports